import angular from 'angular'

import ownerAsk from './services/ask.service'
import ownerData from './services/data.service'
import ownerFormat from './services/format.service'
import ownerGo from './services/go.service'
import ownerLocal from './services/local.service'
import ownerMetadata from './services/metadata.service'
import ownerRequest from './services/request.service'
import ownerResource from './services/resource.service'
import owner from './services/owner.service'

import myOwnerForm from './directives/form/myOwnerForm'
import myOwnerCreateForm from './directives/form/myOwnerCreateForm'
import myOwnerEditForm from './directives/form/myOwnerEditForm'
import myOwnerDisplay from './directives/display/myOwnerDisplay'

import ownerButtons from './resources/buttons.resource'
import ownerIcons from './resources/icons.resource'
import ownerFields from './resources/fields.resource'
import ownerLabels from './resources/labels.resource'

const name = 'owner'
angular.module(name, [])
  // ===== SERVICES ===== //
  .factory('ownerAsk', ownerAsk)
  .factory('ownerData', ownerData)
  .factory('ownerFormat', ownerFormat)
  .factory('ownerGo', ownerGo)
  .factory('ownerLocal', ownerLocal)
  .factory('ownerMetadata', ownerMetadata)
  .factory('ownerRequest', ownerRequest)
  .factory('ownerResource', ownerResource)
  .factory('$$owner', owner)
  // ===== DIRECTIVES ===== //
  .directive('myOwnerForm', myOwnerForm)
  .directive('myOwnerCreateForm', myOwnerCreateForm)
  .directive('myOwnerEditForm', myOwnerEditForm)
  .directive('myOwnerDisplay', myOwnerDisplay)
  // ===== RESOURCES ===== //
  .factory('ownerButtons', ownerButtons)
  .factory('ownerIcons', ownerIcons)
  .factory('ownerFields', ownerFields)
  .factory('ownerLabels', ownerLabels)

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/owner/owner.module.js